export default __webpack_public_path__ + "3c47015.png";